import { render, staticRenderFns } from "./shopIndex.vue?vue&type=template&id=50a9de9c&"
import script from "./shopIndex.vue?vue&type=script&lang=js&"
export * from "./shopIndex.vue?vue&type=script&lang=js&"
import style0 from "./shopIndex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports